export default __webpack_public_path__ + "static/media/plato-fallback.945c835b.svg";